import React, { useState } from "react";

const TermsandCondition = () => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const openDisclaimerModal = () => {
    setShowDisclaimerModal(true);
  };

  const closeDisclaimerModal = () => {
    setShowDisclaimerModal(false);
  };

  return (
    <>
      <div className="container terms my-5">
        <h1 className="mb-4 text-black text-center">Terms and Conditions</h1>
        <p>
          Welcome to <strong>Hunarmand Punjab</strong>.
        </p>
        <p>
          These Terms & Conditions govern your access to and use of the official
          Hunarmand Punjab websites (<strong>hunarmandpunjab.pk</strong> and{" "}
          <strong>hunarmandpunjab.org.pk</strong>) and all services offered
          through these platforms. By accessing our websites or registering for
          any program, you agree to comply with these Terms & Conditions.
        </p>

        <h5 className="mt-4 text-black">Official Websites & Communication</h5>
        <p>The official websites of Hunarmand Punjab are:</p>
        <ul>
          <li>www.hunarmandpunjab.pk</li>
          <li>www.hunarmandpunjab.org.pk</li>
        </ul>
        <p>
          System-generated notifications are sent through the{" "}
          <strong>@hunarmandpunjab.com</strong> email.
        </p>

        <h5 className="mt-4 text-black">1. Program Overview</h5>
        <p>
          Hunarmand Punjab empowers youth with skills, training opportunities,
          job assistance, and other services.
        </p>

        <h5 className="mt-4 text-black">2. Eligibility and Registration</h5>
        <p>
          Users must meet eligibility criteria. Registration is required for
          some services. You're responsible for keeping your account info
          secure.
        </p>

        <h5 className="mt-4 text-black">3. Changes to Terms</h5>
        <p>
          Terms may be updated without notice. Continued use implies acceptance
          of changes.
        </p>

        <h5 className="mt-4 text-black">4. Services and Content</h5>
        <p>
          Content is protected. No copying or reproduction allowed without
          permission.
        </p>

        <h5 className="mt-4 text-black">5. Tuition Fee & Processing Fee</h5>
        <p>
          All training programs offered under Hunarmand Punjab are advertised as
          tuition-free, meaning no monthly or semester tuition fees are charged to
          enrolled participants. A one-time processing fee of <strong>PKR 3,250</strong> is payable
          at the time of enrollment to cover administrative processing, student onboarding,
          Learning Management System (LMS) access, digital resources, verification, and
          related service costs.
          {/* This processing fee is nonrefundable after you get */}
          {/* access to the LMS. You can only claim a refund before you get access to the LMS. */}
          {/* After two days, the processing fee would not be claimable from any legal perspective. */}
          The processing fee is eligible for reimbursement only to participants who complete
          the program and achieve a minimum of 85% marks in the Final Evaluation Test,
          subject to compliance with all applicable program policies and requirements.

        </p>
        {/* <p>
          The processing fee is eligible for reimbursement only to participants who complete
          the program and achieve a minimum of 85% marks in the Final Evaluation Test,
          subject to compliance with all applicable program policies and requirements.
        </p> */}

        <h5 className="mt-4 text-black">6. Final Examination & Scholarship Policy</h5>
        <p>
          The format, schedule, venue, and method of the Final Evaluation Test shall be
          determined solely by the Hunarmand Punjab management. The evaluation may be
          conducted online or physically, depending on academic, operational, quality
          assurance, and integrity requirements. To maintain fairness, transparency, and
          academic standards, Hunarmand Punjab reserves the right to require physical
          examinations where deemed appropriate. Eligibility for the Scholarship Card is
          strictly merit-based. Students who score below 85% in the final examination
          will not be eligible for the Scholarship Card. Final examination results are
          assessed solely on merit under the observation and evaluation of industrial
          trainers. The evaluation process is final, and no requests for rechecking,
          re-evaluation, score revision, or any related claims will be accepted.
        </p>

        <h5 className="mt-4 text-black">7. User Conduct</h5>
        <ul>
          <li>No malware distribution</li>
          <li>No fraudulent activity</li>
          <li>No harassment or discrimination</li>
        </ul>

        <h5 className="mt-4 text-black">8. Privacy and Data Protection</h5>
        <p>Your data is protected under our Privacy Policy.</p>

        <h5 className="mt-4 text-black">9. Disclaimers</h5>
        <p>
          For more information, please read our{" "}
          <button
            onClick={openDisclaimerModal}
            className="text-primary fw-bold text-decoration-underline text-black border-0 bg-transparent"
            style={{ cursor: "pointer", padding: 0 }}
          >
            disclaimer
          </button>{" "}
          section here.
        </p>

        <h5 className="mt-4 text-black">10. Intellectual Property</h5>
        <p>
          All logos, content, and materials are the property of Hunarmand
          Punjab.
        </p>

        <h5 className="mt-4 text-black">11. Termination</h5>
        <p>We may suspend or terminate access for violations of these terms.</p>

        <h5 className="mt-4 text-black">12. Governing Law</h5>
        <p>These terms are governed by the laws of Pakistan.</p>

        <h5 className="mt-4 text-black">13. Contact Information</h5>
        <ul>
          <li>Email: support@hunarmandpunjab.org.pk</li>
          <li>UAN: 03-111-133-053</li>
          <li>Office Address: Lahore, Pakistan</li>
          {/* <li>
            Center for Physical Classes: CHEP Department, Punjab University,
            Lahore, Pakistan
          </li> */}
        </ul>

        <p className="mt-4">
          <strong>
            By using this website, you agree to our Terms and Conditions.
          </strong>
        </p>
      </div>

      {/* Disclaimer Modal */}
      {showDisclaimerModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            padding: "20px",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              maxWidth: "700px",
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
              position: "relative",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              animation: "modalSlideIn 0.3s ease-out",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                background: "#079560",
                color: "white",
                padding: "20px 25px",
                borderRadius: "15px 15px 0 0",
                position: "relative",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: "0",
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Official Disclaimer
                </h3>
                <p
                  style={{
                    margin: "5px 0 0 0",
                    opacity: "0.9",
                    fontSize: "0.9rem",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Hunarmand Punjab Program
                </p>
              </div>

              {/* Close Button */}
              <button
                onClick={closeDisclaimerModal}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "25px",
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  color: "white",
                  fontSize: "18px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.3)";
                  e.target.style.transform = "scale(1.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.2)";
                  e.target.style.transform = "scale(1)";
                }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{
                padding: "25px",
                fontFamily: "Poppins, sans-serif",
                lineHeight: "1.6",
              }}
            >
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                Hunarmand Punjab is an independent initiative established to
                empower Pakistan’s youth through high-quality, career-oriented
                IT and digital skills training. The initiative is not a
                Government of Punjab program, department, or agency and does not
                claim any government ownership, authorization, or official
                status.
              </p>

              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                At the time of its launch, the initiative received moral support
                and appreciation from Rana Sikandar Hayat, Minister for School
                Education, Government of Punjab, in recognition of its vision to
                promote digital skills and youth empowerment. Such support
                should not be interpreted as government ownership, sponsorship,
                administration, or official endorsement of the initiative.
              </p>

              <h5
                className="fw-bold mt-4 mb-2 text-black"
                style={{ fontSize: "15px" }}
              >
                Tuition Fee & Processing Fee
              </h5>
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                All training programs offered under Hunarmand Punjab are
                advertised as tuition-free, meaning no monthly or semester
                tuition fee is charged from enrolled participants. A one-time
                processing fee of PKR 3,250 is payable at the time of enrollment
                to cover administrative processing, student onboarding, Learning
                Management System (LMS) access, digital resources, verification,
                and related service costs.                 The processing fee is eligible for reimbursement only to
                participants who successfully complete the program and achieve a
                minimum of 85% marks in the Final Evaluation Test, subject to
                compliance with all applicable program policies and
                requirements.
              </p>
              {/* <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                The processing fee is eligible for reimbursement only to
                participants who successfully complete the program and achieve a
                minimum of 85% marks in the Final Evaluation Test, subject to
                compliance with all applicable program policies and
                requirements.
              </p> */}

              <h5
                className="fw-bold mt-4 mb-2 text-black"
                style={{ fontSize: "15px" }}
              >
                Final Examination & Scholarship Policy
              </h5>
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                The format, schedule, venue, and method of the Final Evaluation
                Test shall be determined solely by the Hunarmand Punjab
                management. The evaluation may be conducted online or
                physically, depending on academic, operational, quality
                assurance, and integrity requirements. To maintain fairness,
                transparency, and academic standards, Hunarmand Punjab reserves
                the right to require physical examinations where deemed
                appropriate. Eligibility for the Scholarship Card is strictly
                merit-based. Students who score below 85% in the final
                examination will not be eligible for the Scholarship Card. Final
                examination results are assessed solely on merit under the
                observation and evaluation of industrial trainers. The
                evaluation process is final, and no requests for rechecking,
                re-evaluation, score revision, or any related claims will be
                accepted.
              </p>

              <h5
                className="fw-bold mt-4 mb-2 text-black"
                style={{ fontSize: "15px" }}
              >
                Partnerships & Academic Arrangements
              </h5>
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                Hunarmand Punjab may enter into Memorandums of Understanding
                (MoUs) or other collaboration agreements with universities,
                educational institutions, or industry organizations for specific
                academic or operational purposes.
              </p>
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                For example, the MoU with Punjab University facilitates the
                conduct of certain physical classes and related academic
                activities. Such arrangements do not mean that Hunarmand Punjab
                is a sub-campus, department, franchise, affiliated college, or
                official extension of Punjab University unless expressly stated
                in a separate written agreement. Where applicable,
                certifications may be issued in accordance with the terms of the
                relevant collaboration.
              </p>

              <h5
                className="fw-bold mt-4 mb-2 text-black"
                style={{ fontSize: "15px" }}
              >
                Website & Program Management
              </h5>
              <p
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                The Hunarmand Punjab website, admissions process, Learning
                Management System (LMS), student services, examinations,
                scholarship card, policies, and all operational activities are
                independently designed, managed, and administered by the
                Hunarmand Punjab team. No part of the website or its content
                should be interpreted as representing an official government
                portal unless expressly stated.
              </p>

              <h5
                className="fw-bold mt-4 mb-2 text-black"
                style={{ fontSize: "15px" }}
              >
                Right to Amend
              </h5>
              <p
                style={{
                  marginBottom: "0",
                  fontSize: "14px",
                  color: "#1a1e1d",
                }}
              >
                Hunarmand Punjab reserves the right to modify, update, suspend,
                or revise its programs, eligibility criteria, fees,
                reimbursement policy, examination procedures, collaborations,
                website content, and other operational policies at any time
                without prior notice, where necessary for academic,
                administrative, legal, or operational reasons.
              </p>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                padding: "20px 25px",
                borderTop: "1px solid #e9ecef",
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                onClick={closeDisclaimerModal}
                className="btn-green"
                style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default TermsandCondition;
